import { apiCall } from "./api";

export const getReferredusers = async () => {
  return apiCall("/api/v1/get-referred-users", {
    method: "GET",
    credentials: "include",
  });
};
